import { range } from 'lodash';

import { dateTimeCurrent } from 'core/util/datetime';

import * as Types from '../definitions';
import * as Enums from '../enums';

import customer from './customer';
import { mockPromotion as promotion, mockStaticRewardCalculation } from './promotion';

const nowIsoString = dateTimeCurrent();
export const mockClaimDetail: Types.ClaimDetail = {
    id: '',
    number: 0,
    submissionDate: nowIsoString,
    createDate: nowIsoString,
    updateDate: nowIsoString,
    status: Enums.ClaimStatus.PendingValidation,
    reason: null,
    systemReason: null,
    batchExclusions: [],
    customer,
    promotion,
    createdBy: null,
    changedBy: null,
    answers: {},
    rewards: null,
    isForPrefund: false,
    isPartialReward: false,
    reconciliationStatus: Enums.ReconciliationStatus.PendingSubmission,
    reconciliationSubmissionDate: nowIsoString,
    alternatePayee: null,
    hasEsignAgreementAcknowledgement: false,
    rewardAmountTotal: null,
    rewardPointTotal: null,
};

export const mockClaimDetails: Types.ClaimDetail[] = range(1, 5).map((i) => ({
    id: String(i),
    number: i,
    submissionDate: nowIsoString,
    createDate: nowIsoString,
    updateDate: nowIsoString,
    rewardAmount: i * 10,
    status: Enums.ClaimStatus.Validated,
    reason: null,
    systemReason: null,
    batchExclusions: [],
    customer,
    promotion,
    createdBy: null,
    changedBy: null,
    answers: {},
    rewards: null,
    rewardCalculation: mockStaticRewardCalculation,
    isForPrefund: false,
    isPartialReward: false,
    reconciliationStatus: Enums.ReconciliationStatus.PendingSubmission,
    reconciliationSubmissionDate: nowIsoString,
    alternatePayee: null,
    hasEsignAgreementAcknowledgement: false,
    rewardAmountTotal: null,
    rewardPointTotal: null,
}));

export const mockClaimDetailSearchResponse = {
    totalResults: mockClaimDetails.length,
    results: mockClaimDetails,
};

export default mockClaimDetail;
